import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { logException } from "@punchup/sentry";
import {
  addVideosToCollection,
  getComedianManagerCollections,
} from "../../client/manager/collections";
import { CollectionRow } from "../../models/collections";

export const managerCollectionsQueryKey = (comedianId: string) =>
  ["managerCollections", comedianId] as const;

export function useManagerCollections(
  comedianId: string,
  options?: { enabled?: boolean }
): UseQueryResult<CollectionRow[], Error> {
  return useQuery({
    queryKey: managerCollectionsQueryKey(comedianId),
    queryFn: () => getComedianManagerCollections(comedianId),
    enabled: !!comedianId && options?.enabled !== false,
    staleTime: 60_000,
  });
}

export function useAddVideosToCollection(
  comedianId: string
): UseMutationResult<
  void,
  Error,
  { collectionId: string; specialIds: string[] }
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      collectionId,
      specialIds,
    }: {
      collectionId: string;
      specialIds: string[];
    }) => addVideosToCollection(collectionId, specialIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managerCollectionsQueryKey(comedianId),
      });
    },
    onError: (err) => {
      logException(err, {
        data: "[useAddVideosToCollection] Failed to add videos to collection",
      });
    },
  });
}
